import PropTypes from 'prop-types';
import React from 'react';

import { SideBar } from '$partials/global';
import { Stream as ModuleStream } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Footer = ({
    copyright = null,
    links     = null,
    modules   = null
}) => {
    return (
        <footer className='footer relative bg-white'>
            <div className='container'>
                {/* modules*/}
                <ModuleStream
                    modules={modules}
                    namespace='footer' />

                {/* copyright */}
                <div className='module module--footer'>
                    <div className='pr-gutter mxn-gutter'>
                        <div className='flex flex-wrap'>
                            {/* side title */}
                            <div className='absolute top-0 md-relative md-col-2' />

                            {/* content */}
                            <div className='col-7 sm-col-9 md-col-8'>
                                <div className='ml9 sm-ml9 md-ml0'>
                                    <div className='px-gutter'>
                                        <p className='type-style-5 py5'>
                                            {copyright}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {links?.length > 0 && (
                                <div className='col-5 sm-col-3 md-col-2'>
                                    <div className='px-gutter align-right'>
                                        <ul className='list-reset py5'>
                                            {links?.map((link, idx) => {
                                                return (
                                                    <li key={idx}>
                                                        <a
                                                            className='link-reset block type-style-5'
                                                            href={link.page?.url}>
                                                            {link.page?.title}
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    copyright: PropTypes.string.isRequired,
    links:     PropTypes.array,
    modules:   PropTypes.array
};

Footer.propTypes = propTypes;

export { Footer };

export default Footer;
